module.exports = __webpack_public_path__ + "static/img/exit-fullscreen.3246b91d.svg";